import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedInfo = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="info" size="100%" color={stroke ?? color} />
);

export { LineRoundedInfo };
